import axios from '../lib/axios';
import { Product, CreateProductDto, UpdateProductDto } from '../types/product';

export const productService = {
  getProducts: async () => {
    const { data } = await axios.get<Product[]>('/products');
    return data;
  },

  createProduct: async (product: CreateProductDto) => {
    const { data } = await axios.post<Product>('/products', product);
    return data;
  },

  updateProduct: async (code: string, product: UpdateProductDto) => {
    const { data } = await axios.put<Product>(`/products/${code}`, product);
    return data;
  },

  deleteProduct: async (code: string) => {
    await axios.delete(`/products/${code}`);
    return code;
  },
}; 